import React from 'react'
import PropTypes from 'prop-types'
// import AlertContainer from 'react-alert'
// import { alertOptions } from '../../../resources/utilities'
import { polyglot } from '../../../index'

class FileInput extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: '',
      savedValue: props.savedValue
    }
    this.renderAlertContainer = this.renderAlertContainer.bind(this)
    this.handlePictureChange = this.handlePictureChange.bind(this)
    this.handlePdfChange = this.handlePdfChange.bind(this)
  }

  componentWillMount () {
    this.setState({
      savedValue: this.props.savedValue
    })
  }

  handlePictureChange (e) {
    if (e.target.files && e.target.files[0]) {
      const reader = new window.FileReader()
      reader.onload = (e) => {
        this.refs.image.src = e.target.result
        if (this.refs.image.files[0].size > 1000000) {
          this.refs.image.src = undefined
          this.refs.image.value = ''
          // this.msg.error('Excedeu o tamanho da imagem (tamanho máximo 1 Mb) ')
        } else {
          this.props.handleSubmit(this.props.name, e.target.result)
        }
      }
      reader.readAsDataURL(e.target.files[0])
    }
  }

  handlePdfChange2 (e) {
    if (this.refs.pdf.files[0]) {
      if (this.refs.pdf.files[0].size > 1000000) {
        this.refs.pdf.src = undefined
        this.refs.pdf.value = ''
        // this.msg.error('Excedeu o tamanho do ficheiro (tamanho máximo 1 Mb) ')
      } else {
        this.props.handleSubmit(this.props.name, this.refs.pdf.files[0])
      }
    }
  }

  handlePdfChange (e) {
    const array = this.refs.pdf.files
    const filesObject = []
    if (array.length > 0) {
      Object.keys(array).forEach(key => {
        const file = array[key]
        if (file.size > 1000000) {
          this.refs.pdf.src = undefined
          this.refs.pdf.value = ''
          // this.msg.error(polyglot.t('staticFields.commonFields.maxFileSizeWarning'))
        } else {
          filesObject.push(file)
        }
      })
      if (filesObject.length > 0) {
        console.log(filesObject)
        this.props.handleSubmit(this.props.name, filesObject)
      }
    }
  }

  renderAlertContainer () {
    return null
    // return <AlertContainer ref={a => { this.msg = a }} {...alertOptions} />
  }

  renderOpenButton (link) {
    if (validURL(link)) {
      return <a href={link} target='_blank' rel='noopener noreferrer'><p className='form-control-static'>{polyglot.t('staticFields.commonFields.open')}</p></a>
    } else {
      return <p className='form-control-static'>Not supported Yet.</p>
    }
  }

  render () {
    if (this.props.type === 'image') {
      return <div className={`${this.state.loading}`}>
        {this.renderAlertContainer()}
        {this.state.savedValue
          ? this.renderOpenButton(this.state.savedValue)
          : <input
            multiple={this.props.multiple}
            ref='image'
            type='file'
            required={this.props.required}
            maxLength={100000}
            placeholder={this.props.placeholder}
            accept='image/*'
            name={this.props.name}
            className={'form-control'}
            onChange={(e) => this.handlePictureChange(e)} />
        }
      </div>
    } else if (this.props.type === 'pdf') {
      return <div className={`${this.state.loading}`}>
        {this.renderAlertContainer()}
        {this.state.savedValue
          ? this.renderOpenButton(this.state.savedValue)
          : <input
            ref='pdf'
            multiple={this.props.multiple}
            type='file'
            required={this.props.required}
            maxLength={100000}
            placeholder={this.props.placeholder}
            accept='application/pdf'
            name={this.props.name}
            className={'form-control'}
            onChange={(e) => this.handlePdfChange(e)} />
        }
      </div>
    } else {
      return <div>Wrong Format</div>
    }
  }
}

FileInput.propTypes = {
  required: PropTypes.bool,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  multiple: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  savedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
}

FileInput.defaultProps = {
  required: true
}

function validURL (str) {
  let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
    '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
  return pattern.test(str)
}

export { FileInput }



// WEBPACK FOOTER //
// ./src/components/common/FileInput/FileInput.js